import React, { useState } from "react";
import { connect, useSelector } from "react-redux";
import {
  getUserRoleId,
  getClientid,
  getRoleList,
  getUserRole,
  getMenuList,
  getUserList,
  getUserInfo,
} from "redux/selectors";
import { Row, Col, Button } from "antd";
import styled from "@emotion/styled";
import CheckInCheckout from "molecules/CheckInCheckout";
import UserMonthlyReport from "molecules/UserMonthlyReport";
import UserCheckinReport from "molecules/UserCheckinReport";
import NonStaffDashboard from "molecules/NonStaffDashboard";
import UserLeaveReport from "molecules/UserLeaveReport";
import BirthdaySpotLight from "./DashboardComponent/BirthdaySpotLight";
import AnnouncementList from "./DashboardComponent/AnnouncementList";
import UpcommingHolidayLists from "./DashboardComponent/UpcommingHolidayLists";
import MyTaskList from "./DashboardComponent/MyTaskList";
import { EyeFilled } from "@ant-design/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ButtonFilled } from "reusableComponent/UIButtons";
import ClientFeedback from "./ClientFeedback/ClientFeedback";

const StyledRow = styled(Row)`
  padding-top: 5px;
`;

const GutterCol = styled(Col)`
  margin-bottom: 25px;
`;

const StyledButton = styled(Button)`
  color: #2d53da;
  border-radius: 10px;

  :disabled {
    color: #e3e8fc !important;
  }
  // :hover {
  //   background: #c5cff5;
  // }
`;

const MyDashboard = ({ userRoleId, userInfo }) => {
  const menuList = useSelector(getMenuList);
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isTaskView = Menulist?.find(
    (item) => item?.key === "taskmanagement"
  )?.access;
  const history = useHistory();
  return (
    <div>
      <div className="w-100 text-end px-2">
        <StyledButton
          type="link"
          // style={{ fontSize: 20 }}
          className=""
          onClick={() => setIsModalOpen(true)}
        >
          Client Feedback
        </StyledButton>
        <EyeFilled
          style={{ fontSize: 20 }}
          className=""
          onClick={() => history.push("/myshift")}
        />
      </div>

      <>
        <StyledRow gutter={[16, 0]}>
          {/* Row 1: CheckIn + Monthly | Announcement */}
          <GutterCol xs={24} sm={24} xl={12}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <CheckInCheckout />
              </Col>
              <Col span={24}>
                <UserMonthlyReport />
              </Col>
            </Row>
          </GutterCol>
          {isTaskView && (
            <GutterCol xs={24} sm={24} xl={12}>
              <MyTaskList />
            </GutterCol>
          )}

          {/* Row 2: CheckIn Report | MyTask */}
          <GutterCol xs={24} sm={24} xl={12}>
            <UserCheckinReport />
          </GutterCol>

          <GutterCol xs={24} sm={24} xl={isTaskView ? 12 : 24}>
            <AnnouncementList />
          </GutterCol>

          {/* Row 3: Birthday | Upcoming Holidays */}
          <GutterCol xs={24} sm={24} md={12}>
            <BirthdaySpotLight />
          </GutterCol>

          <GutterCol xs={24} sm={24} md={12}>
            <UpcommingHolidayLists />
          </GutterCol>

          {/* Row 4: Leave Report */}
          <GutterCol xs={24}>
            <UserLeaveReport />
          </GutterCol>
        </StyledRow>
      </>

      {userRoleId == 1 && <NonStaffDashboard />}
      <ClientFeedback
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  ClientId: getClientid(state),
  roleList: getRoleList(state),
  userRoleType: getUserRole(state),
  menuList: getMenuList(state),
  userList: getUserList(state),
  userInfo: getUserInfo(state),
});

export default connect(mapStateToProps, null)(MyDashboard);
